import { useEffect, useRef } from "react";
import "./Map.css";

function Map({
  title = "",
  description = "",
  mapSrc = "",
  address = "",
  directionLink = "",
  cardColor = "",
  primaryColor = "",
  secondaryColor = "",
}) {
  const titleRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("section-title-visible");
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.3,
        rootMargin: "0px 0px -10% 0px",
      },
    );

    if (titleRef.current) observer.observe(titleRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      id="map-section"
      className="map-section"
      style={{
        "--primary-color": primaryColor,
        "--secondary-color": secondaryColor
      }}>
      <div className="map-section-title" ref={titleRef}>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      <div className="map-container" style={{ background: cardColor }}>
        <iframe
          title="Location of Majestic Gen Sphere near Malaysia-Singapore border."
          className="map"
          src={mapSrc}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
        <div className="map-info-container">
          <p className="container-title">Location</p>
          <p className="address-text">
            {address}
          </p>
          <a href={directionLink}>
            <span className="material-symbols">near_me</span>
            Direction
          </a>
        </div>
      </div>
    </div>
  );
}

export default Map;
